module.exports = __webpack_public_path__ + "static/media/ana-lucena-4.617261b5.jpeg";